// @ts-nocheck
import { Intent, OverlayToaster, Toaster } from "@blueprintjs/core"
import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { BrowserRouter } from "react-router-dom"
import APIProvider from "./APIProvider"
import AuthProvider from "./AuthProvider"
import ScientRouter from "./Routes"

const queryToaster: Toaster = await OverlayToaster.create({ position: "top-right" })

const queryClient = new QueryClient({
  defaultOptions: {
    /**
     * Disable refetch on window focus by default.
     */
    refetchOnWindowFocus: false,
    staleTime: 10 * (60 * 1000), // 10 mins
    cacheTime: 15 * (60 * 1000), // 15 mins
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query?.meta?.toasterErrorMessage) {
        queryToaster.show({
          message: query.meta.toasterErrorMessage,
          intent: Intent.DANGER,
        })
      }
    },
  }),
})

const App = () => {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <APIProvider>
          <AuthProvider>
            <ScientRouter />
            <ReactQueryDevtools initialIsOpen={false} position="bottom-left" />
          </AuthProvider>
        </APIProvider>
      </QueryClientProvider>
    </BrowserRouter>
  )
}

export default App
